(function() {
  'use strict';

  function PreferredModeDirective($log, Auth) {
    return {
      restrict: 'A',
      template: 'Preferred mode: {{ preferredMode }}',
      link: function($scope) {
        Auth.processSettings();
        $scope.$watch(function() {
          return Auth.preferredMode;
        }, function(status) {
          $log.debug('PreferredMode: ' + status);
          $scope.preferredMode = status;
        });
      }
    };
  }

  function LogoDirective(Auth, Organisations) {
    return {
      restrict: 'AE',
      replace: true,
      scope: {
        type: '@',
        organisation: '@'
      },
      templateUrl: 'app/blocks/auth/logo.html',
      link: function(scope) {
        var logins = Organisations.findAllPublic();

        var setLogoPath = function(currOrg, device) {
          logins.then(function(availableLogins) {
            var logoPath;
            var org = _.find(availableLogins.logins, { id: currOrg });
            if (org) {
              logoPath = device && device === 'mobile'
                ? (org.themeSetup || {}).logoMobilePath
                : (org.themeSetup || {}).logoDesktopPath;

              // If the organisation hasn't set up a logo, we use the default one
              if (logoPath === undefined || logoPath === null || logoPath.length < 1) {
                logoPath = 'assets/images/default-org-logo.webp';
              }
            }

            scope.imgSrc = logoPath;
            scope.imgAlt = org ? org.name : 'Organisation logo';
          });
        };

        scope.$on('OrganisationSettingsChanged', function() {
          logins = Organisations.findAllPublic();
          setLogoPath(Auth.currentOrganisation());
        });

        scope.$watch(function() {
          return scope.organisation || Auth.currentOrganisation();
        }, function(currOrg) {
          setLogoPath(currOrg, scope.type);
        });
      }
    };
  }

  LogoDirective.$inject = ['AuthService', 'OrganisationsService'];

  PreferredModeDirective.$inject = ['$log', 'AuthService'];

  angular.module('blocks.auth')
    .directive('kzPreferredMode', PreferredModeDirective)
    .directive('kzLogo', LogoDirective);
})();
